const Modal = ({ handleOut, width, children }) => {
    return (
        <>
            <div onClick={() => handleOut()} className="absolute left-0 top-0 w-screen h-[100vh] bg-gray-900/80 z-[10]"></div>
            <div className={`fixed z-[11] ${width} bg-black top-1/2 left-1/2 translate-x-[-50%] translate-y-[-50%] rounded-[10px]`}>
                      {children}
            </div>
        </>
    );
};

export default Modal;